import { render, staticRenderFns } from "./ProductDetailsTile.vue?vue&type=template&id=6e327799&"
import script from "./ProductDetailsTile.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports